
<template>
    <div class="add-coach-reserve-components" :class="step == 1 ? 'add-reserve-components' : ''">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Lesson.dai')"
            left>
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                :label-position="step == 1 ? 'right' : 'left'"
                :label-width="step == 1 ? '90px' : '120px'"
                label-suffix=":">
                <!-- step 1 -->
                <div v-if="step == 1" class="step-one" >
                    <el-form-item  prop="storeId" :label="$t('Lesson.store')">
                        <el-select
                            class="pr-2"
                            v-model="form.storeId">
                            <el-option
                                v-for="item in stores"
                                :key="item.id"
                                :label="item.name"
                                :value="Number(item.id)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="clientId" :label="$t('Member.Desc.search')">
                        <el-select
                            v-model="form.clientId"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="handleSelect"
                            v-on:change="fetchStepOne"
                            :loading="loading">
                            <el-option
                                v-for="item in clients"
                                :key="item.id"
                                :label="item.resultText"
                                :value="Number(item.id)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <!-- step 2 & step 3 -->
                <div v-show="step != 1" class="add-coach-userinfo">
                    <div>
                        <span>{{ $t('Member.name2') }}：{{ clientInfo.clientName }}</span>
                        <span>{{ $t('Member.telephone') }}：{{ clientInfo.clientPhone }}</span>
                    </div>
                    <div>{{ $t('Common.card_number') }}：{{ clientInfo.cardNum }}</div>
                    <div>{{ $t('Common.member_card_number') }}：{{ clientInfo.cardName }}</div>
                    <div>{{ $t('Member.start_end_date') }}：{{ clientInfo.memberShipTime }}</div>
                </div>
                <!-- step 2 -->
                <div v-show="step == 2">
                    <el-form-item :label="$t('Choose.dai')">
                        <el-select
                            v-on:change="fetchContract"
                            class="add-coach-select"
                            v-model="form.lessonId"
                            :placeholder="$t('Choose.lesson')">
                            <el-option
                                v-for="(item, index) in lessons"
                                :key="index"
                                :label="`${item.name} | ${item.duration}`"
                                :value="Number(item.id)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="add-coach-label" :label="$t('Choose.appoint_card')">
                        <el-radio-group
                            v-if="contracts && contracts.length"
                            class="add-coach-radio"
                            v-model="chooseCard"
                        >
                            <el-radio
                                v-for="(i, iindex) in contracts"
                                :key="iindex"
                                :label="i"
                            >
                                {{ i.cardName }}
                            </el-radio>
                        </el-radio-group>
                        <div v-if="!contracts.length" class="add-coach-contracts-none">
                            {{ $t('Choose.no_contract') }}
                        </div>
                    </el-form-item>
                    <el-form-item
                        v-show="contracts.length"
                        class="add-coach-frequency"
                        :label="$t('Course.Appoint.frequency')"
                        prop="quantity">
                        <div class="flex">
                            <el-input :placeholder="$t('Course.Appoint.fill_fre')" v-model="form.quantity" />
                            <span>{{ $t('Board.Team.festival') }}</span>
                        </div>
                    </el-form-item>
                </div>
                <!-- step 3 -->
                <div v-show="step == 3">
                    <div class="add-coach-userinfo">
                        <div>
                            <span>{{ $t('Course.name') }}：{{ lessonInfo.lessonName }}</span>
                            <span v-if="lessonInfo.contractType === 4">
                                {{ $t('Course.Appoint.card_name') }}：{{ lessonInfo.czCardName }}
                            </span>
                            <span v-if="lessonInfo.contractType === 2">
                                {{ $t('Course.coach') }}：{{ lessonInfo.coachNickname }}
                            </span>
                        </div>
                        <div>
                            <span>
                                {{ $t('Course.Appoint.buy') }}{{ lessonInfo.contractType === 4
                                ? this.$t('Course.Appoint.amt')
                                : $t('Course.Appoint.frequency2') }}：{{ lessonInfo.lessonCredit }}
                            </span>
                            <span>
                                {{ $t('Reception.First.remaining') }}
                                {{ lessonInfo.contractType === 4
                                ? this.$t('Course.Appoint.amt')
                                : $t('Course.Appoint.frequency2') }}：{{ lessonInfo.lessonBalance }}
                            </span>
                        </div>
                        <div>
                            <span>{{ $t('Course.Appoint.time') }}：{{ lessonInfo.lessonDuration }}</span>
                            <span v-if="lessonInfo.contractType === 4">
                                {{ $t('Card.pay') }}：{{ lessonInfo.lessonRate }}
                            </span>
                            <span v-if="lessonInfo.contractType === 2">
                                {{ $t('Course.Appoint.end_time') }}：{{ lessonInfo.lessonEndAt }}
                            </span>
                        </div>
                    </div>
                    <el-form-item :label="$t('Course.Appoint.appoint_ci')">
                        {{ `${lessonInfo.quantity}${$t('Board.Team.festival')}` }}
                    </el-form-item>
                    <el-form-item :label="$t('Common.choose_date2')">
                        <el-date-picker
                            @change="fetchCoach"
                            v-model="form.lessonDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :placeholder="$t('Common.choose_date2')">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="add-coach-label" :label="$t('Course.Appoint.time_coach')">
                        <div class="add-coach-select-table" :class="!coachs.length ? 'select-table-width' : ''">
                            <swiper
                                v-if="coachs && coachs.length"
                                class="add-coach-swiper"
                                :pagination="false"
                                :navigation="true"
                                :config="config">
                                <div
                                    v-for="(item, index) in coachs"
                                    :key="index"
                                    class="add-coach-item">
                                    <div class="add-coach-name flex justify-center items-center">
                                        {{ item.coachNickname }}
                                    </div>
                                    <ul>
                                        <li
                                            :class="(item.scheduleTimes[iidex].isFreeTime
                                            && clickItem
                                            && clickItem.lessonTime === i
                                            && clickItem.coachId === item.coachId)
                                            ? 'add-coach-checked'
                                            : (item.scheduleTimes[iidex].isFreeTime
                                            && !clickItem)
                                            || (item.scheduleTimes[iidex].isFreeTime
                                            && clickItem
                                            && clickItem.lessonTime != item.i)
                                            ? 'add-coach-free' : ''"
                                            @click="clickCoach(item.coachId, i, item.scheduleTimes[iidex].isFreeTime)"
                                            v-for="(i, iidex) in lessonTime"
                                            :key="iidex">
                                            {{ i }}
                                        </li>
                                    </ul>
                                </div>
                                <!-- 按钮 -->
                                <div
                                    slot="navigation">
                                    <div
                                        class="swiper-prev swiper-button absolute">
                                        <div class="iconfont icon-fitness-leftarrow"></div>
                                    </div>
                                    <div
                                        class="swiper-next swiper-button absolute">
                                        <div class="iconfont icon-fitness-rightarrow"></div>
                                    </div>
                                </div>
                            </swiper>
                            <div class="add-coach-contracts-none" v-if="!coachs.length && isStoreMatched">
                                {{ $t('Course.Appoint.no_set') }}
                            </div>
                            <div class="add-coach-contracts-none" v-if="!coachs.length && !isStoreMatched">
                                <div>{{ coachNickname }}</div>
                                <div style="margin-top: -10px;">{{ $t('Course.Appoint.no_store_coach') }}</div>
                            </div>
                        </div>
                    </el-form-item>
                </div>
                <!-- step 2 & step 3 footer-btn -->
                <div v-show="step != 1" class="add-coach-footer-btn flex justify-center">
                    <el-button @click="backStep">{{ $t('Common.prev_step') }}</el-button>
                    <el-button
                        @click="nextStep"
                        v-if="step == 2 && contracts.length"
                        type="primary">{{ $t('Common.next_step') }}</el-button>
                    <el-button
                        v-if="step == 3"
                        @click="confirm"
                        type="primary"
                    >{{ $t('Message.confirm') }}</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { Dialog, Option, Select, Form, Radio, RadioGroup, DatePicker } from 'element-ui';
import Swiper from '@/components/base/Swiper.vue';
import timeMixin from '../../../mixins/timeMixin.js';

export default {
    name: 'add-coach-reserve',
    components: {
        Swiper,
        ElDialog: Dialog,
        ElOption: Option,
        ElSelect: Select,
        ElForm: Form,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
        ElDatePicker: DatePicker,
    },
    mixins: [timeMixin],
    data() {
        return {
            visible: false,
            loading: false,
            form: {
                // public
                storeId: null,
                clientId: null,
                // step 2
                lessonId: null,
                // step 2 => step 3
                contractNum: null,
                quantity: '1',
                // step 3
                lessonDate: null,
            },
            rules: {
                quantity: { required: true, type: 'string', message: this.$t('Course.Appoint.choose_ci') },
            },
            // step 1
            stores: [],
            clients: [],
            clientInfo: {},
            step: 1,
            // step 2
            lessons: [],
            contracts: [],
            chooseCard: null,
            // step 3
            lessonInfo: {},
            coachs: [],
            config: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 4,
                slidesPerGroup: 4,
                spaceBetween: 0,
                autoplay: false,
            },
            lessonTime: [],
            clickItem: null,
            isStoreMatched: true,
            coachNickname: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.handleReset();
        },
    },
    methods: {
        handleReset() {
            this.step = 1;
            this.clients = [];
            this.clientInfo = {};
            this.form = {
                storeId: null,
                clientId: null,
                lessonId: null,
                contractNum: null,
                quantity: '1',
                lessonDate: null,
            };
            this.form.quantity = '1';
            this.clickItem = null;
        },
        filterTime(date, type) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            const hour = date.getHours();
            let minutes = date.getMinutes();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            if (minutes < 10) minutes = `0${minutes}`;

            const result = !type ? `${year}-${month}-${day}` : `${hour}:${minutes}`;
            return result;
        },
        backStep() {
            if (this.step === 2) {
                this.form.clientId = null;
                this.clients = [];
                this.form.lessonId = null;
                this.step = 1;
            } else if (this.step === 3) {
                this.step = 2;
            }
        },
        nextStep() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.step = 3;
                this.fetchStepThree();
            });
        },
        open() {
            this.fetchStore();
            this.visible = true;
        },
        // 门店
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
                this.form.storeId = this.form.storeId || res[0].id;
            });
        },
        // 用户
        handleSelect(val) {
            this.loading = true;
            API.get('lesson/coach/schedule/search-client', {
                params: {
                    keyword: val,
                },
            }).then(res => {
                this.clients = res;
            }).finally(() => {
                this.loading = false;
            });
        },
        // 根据获取的信息选择课程
        async fetchStepOne() {
            await API.get('lesson/coach/schedule/reserve/step1', {
                params: this.form,
            }).then(res => {
                this.clientInfo = res;
            });
            this.fetchLesson();
            this.step = 2;
        },
        // 获取私教课程列表
        fetchLesson() {
            const form = {
                active: true,
                storeId: this.form.storeId,
            };
            API.get('lesson/coach/list', {
                params: form,
            }).then(res => {
                this.lessons = res;
                if (res.length) {
                    this.form.lessonId = this.form.lessonId || res[0].id;
                    this.fetchContract();
                }
            });
        },
        // 选择课程后获取是否存在可选合同
        fetchContract() {
            const form = Object.assign({}, this.form);
            delete form.lessonDate;
            API.get('lesson/coach/schedule/reserve/available-card', {
                params: form,
            }).then(res => {
                this.contracts = res;
                if (res && res.length) this.chooseCard = res[0];
                console.log(this.chooseCard);
                // if (res && res.length) {
                //     this.form.contractNum = this.form.contractNum || res[0].contractNum;
                // }
            });
        },
        // 选择合同及节数后获取详细信息
        fetchStepThree() {
            this.form.contractNum = this.chooseCard.contractNum;
            const form = Object.assign({}, this.form);
            delete form.lessonDate;
            API.get('lesson/coach/schedule/reserve/step2', {
                params: form,
            }).then(res => {
                this.lessonInfo = res;
                this.form.lessonDate = this.form.lessonDate || this.filterTime(new Date());
                this.fetchCoach();
            });
        },
        // 获取可生课教练及时间
        fetchCoach() {
            this.form.coachId = this.chooseCard.coachId;
            const form = Object.assign({}, this.form);
            API.get('lesson/coach/schedule/reserve/time', {
                params: form,
            }).then(res => {
                // 该教练是否属于当前门店 isStoreMatched - false - true
                if (res.length === 1 && !res[0].isStoreMatched) {
                    this.isStoreMatched = res[0].isStoreMatched;
                    this.coachNickname = res[0].coachNickname;
                    res = [];
                } else res = res.filter(el => el.isStoreMatched);
                // 定义轮播数
                if (res.length >= 4) {
                    this.config.slidesPerView = 4;
                    this.config.slidesPerGroup = 4;
                } else {
                    this.config.slidesPerView = res.length;
                    this.config.slidesPerGroup = res.length;
                }
                if (res && res.length) {
                    let array = [];
                    array = res[0].scheduleTimes.map(el => el.time);
                    // 赋值
                    this.lessonTime = array;
                }
                this.coachs = res;
            });
        },
        clickCoach(coachId, time, isFreeTime) {
            if (isFreeTime) {
                this.clickItem = {
                    coachId: coachId,
                    lessonTime: time,
                };
            } else {
                this.clickItem = null;
            }
        },
        confirm() {
            if (!this.isStoreMatched && this.coachNickname) {
                return $ele.$message(`${this.coachNickname}${this.$t('Course.Appoint.no_store_coach')}`);
            }

            if (!this.coachs.length) return $ele.$message(this.$t('Course.Appoint.no_set'));
            if (!this.clickItem) return $ele.$message(this.$t('Course.Appoint.time_coach2'));
            const form = Object.assign({}, this.form, this.clickItem);
            API.post('lesson/coach/schedule', form).then(() => {
                $ele.$message.success(this.$t('Card.appoint_success'));
                this.$emit('fetchData');
                this.visible = false;
            });
        },
    },
};
</script>

<style lang="scss">
.add-coach-reserve-components {
    .el-dialog {
        width: 600px;
        height: 550px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    // step 3
    ul {
        margin: 0;
        padding: 0;
        font-size: 13px;
        color: #575757;
    }
    li {
        list-style: none;
        list-style-position: inside;
        background: #f8f8f8;
        padding: 10px;
        border-left: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        cursor: pointer;
    }
    .add-coach-free {
        background: #fff;
    }
    .add-coach-checked {
        background: #05abef;
        color: #fff;
    }
    .swiper-wrapper {
        border-right: 1px solid #e6e6e6;
    }
    .swiper-button {
        top: 50px;
        z-index: 2;

        .iconfont {
            font-size: 30px;
        }
    }
    .swiper-prev {
        left: -20px;
    }
    .swiper-next {
        right: -20px;
    }
    .swiper-container {
        position: static;
    }
}
.add-reserve-components {
    .el-dialog__body {
        margin-left: 30px;
    }
}
// step 1
.add-coach-userinfo {
    font-size: 13px;
    border: 1px solid #e6e6e6;
    background: #f7f7f7;
    padding: 10px;
    color: #666;
    margin-bottom: 15px;
    div {
        margin: 10px 0;
    }
    span {
        display: inline-block;
        width: 50%;
    }
}
// step 2
.add-coach-select {
    .el-input {
        width: 270px;
    }
}
.add-coach-label {
    .el-form-item__label {
        width: 100% !important;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
.add-coach-radio {
    .el-radio {
        width: 100%;
        margin: 6px 0;
    }
    .el-radio+.el-radio {
        margin-left: 0;
    }
    .el-radio__label {
        font-size: 13px;
        color: #666;
        font-weight: 400;
    }
}
.add-coach-contracts-none {
    color: #db093f;
    font-size: 12px;
}
.add-coach-footer-btn {
    margin: 50px 0;
}
// step 3
.add-coach-frequency {
    margin-top: 30px;
    border-top: 1px solid #e6e6e6;
    padding-top: 20px;
    .el-input {
        width: 170px;
        margin-right: 6px;
    }
}
.add-coach-select-table {
    width: calc(100% - 30px);
    margin: auto;
    white-space: nowrap;
    overflow-x: auto;
    max-height: 360px;
    overflow-y: auto;
}
.select-table-width {
    width: 100%;
}
.add-coach-item {
    display: inline-block;
    text-align: center;

    &:last-child {
        border-right: 1px solid #e6e6e6;
    }
}
.add-coach-name {
    background: #879098;
    color: #fff;
    padding: 10px;
    border-left: 1px solid #66717b;
    white-space: normal;
    vertical-align: middle;
    min-height: 85px;
    word-break: break-all;
}
</style>
